<template>
  <birthday v-bind="$attrs" v-on="$listeners" v-slot="{ close }">
    <validation-observer v-slot="{ handleSubmit }">
      <v-container v-if="$attrs.template === 'your-birthday'">
        <img
          :src="iconClose3"
          height="30"
          width="30"
          alt=""
          class="position-absolute top-9 right-9 cursor-pointer"
          @click="close"
        />
        <v-row class="happy_birthday__info_user">
          <v-col class="text-center text-color--black">
            <v-avatar size="60" class="avatar">
              <img :src="$attrs.staff.avatar" :alt="$attrs.staff.avatar" />
            </v-avatar>
            <span class="name">{{ $attrs.staff.name }}</span>
          </v-col>
        </v-row>
        <v-row class="happy_birthday__content">
          <v-col class="text-center">
            <span class="birthday-title amber--text">HAPPY BIRTH DAY</span>
          </v-col>
        </v-row>
      </v-container>
      <v-container v-else class="other position-relative">
        <img
          :src="iconClose3"
          height="30"
          width="30"
          alt=""
          class="position-absolute top-9 right-9 cursor-pointer"
          @click="close"
        />
        <v-row class="happy_birthday__info_user">
          <v-col class="text-center text-color--black">
            <v-avatar size="50" class="avatar">
              <img :src="$attrs.staff.avatar" alt="John" />
            </v-avatar>
            <span class="name">{{ $attrs.staff.abbreviateName }}</span>
          </v-col>
        </v-row>
        <v-row class="happy_birthday__content mt-1" no-gutters>
          <v-col class="text-center">
            <span class="birthday-title amber--text">HAPPY BIRTH DAY</span>
          </v-col>
        </v-row>
        <v-row class="happy_birthday__comment mt-3" no-gutters>
          <v-col>
            <validation-provider
              :name="$t('common.message')"
              rules="required"
              v-slot="{ errors }"
            >
              <v-textarea
                outlined
                color="black"
                :label="$t('common.message')"
                :placeholder="$t('common.message')"
                v-model="messageData.message"
                :error-messages="errors"
                rows="2"
                class="text_area"
                hide-details
              />
            </validation-provider>
          </v-col>
        </v-row>
        <v-row class="happy_birthday__point mt-3" no-gutters>
          <v-col class="d-flex justify-space-between select-point">
            <v-select
              v-model="giftPoint"
              hide-details
              color="black"
              :items="listPoint"
              :label="$t('common.selectNumberOfPointsToSend')"
              item-value="value"
              class=""
              outlined
              dense
            />
          </v-col>
        </v-row>
        <v-row class="happy_birthday__action send_point" no-gutters>
          <v-col class="text-center mt-5">
            <v-btn
              class="send_point__btn"
              @click="handleSubmit(() => save(close))"
            >
              {{ $t('common.sendPoint') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </validation-observer>
  </birthday>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import iconClose3 from '@/assets/icons/close-3.png';
import * as numeral from 'numeral';
import Birthday from './Birthday.vue';

export default {
  name: 'HappyBirthDay',
  components: { Birthday },
  data: () => ({
    sentGift: false,
    loading: false,
    chooseBtnIndex: -1,
    giftPoint: 0,
    messageData: {
      point: undefined,
      message: undefined,
      categoryId: undefined,
    },
    iconClose3,
  }),
  computed: {
    ...mapGetters('gift', ['categoryItems']),
    ...mapGetters('staff', ['currentStaff']),
    listPoint() {
      const points = this.currentStaff.defaultGiftPoint.map((p) => {
        const item = {
          value: p,
          text: numeral(p).format('0,0'),
        };
        return item;
      });
      points.unshift({
        value: null,
        text: '0',
      });
      return points;
    },
  },
  methods: {
    ...mapActions('staff', ['fetchCurrentStaff']),
    async save(callback) {
      if (this.loading) {
        return;
      }
      try {
        this.loading = true;
        const gift = {
          ...this.messageData,
          gift: this.giftPoint,
          staffToId: this.$attrs.staff.id,
        };
        await this.$APIBuilder.store('gift').createOne(gift);
        this.message = '';
        this.giftCategory = undefined;
        await this.$cheeers.notify({
          text: this.$t('give.action.success'),
        });
        this.sentGift = true;
        callback();
      } catch (e) {
        await this.$cheeers.notify({
          text: this.$t('give.action.fail'),
          type: 'error',
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="sass">
.select-point
  .v-input__slot fieldset
    background-color: #efcc55 !important
.happy_birthday
  box-shadow: none !important
  .v-select__slot
    label
      font-size: 13px !important
  .theme--dark.v-label, .v-select__selection--comma
    color: black !important
  .v-input__slot fieldset
    color: #f68f3c !important
    border: 3px solid
  .v-icon
    color: #f68f3c !important
.birthday-title
  font-family: 'SansitaOne', "Roboto", sans-serif
.happy_birthday
  box-shadow: none !important
  .main-card
    background-image: url("../../../../assets/image/notification/template/happy_birthday2.png")
    position: relative
    background-color: transparent !important
    box-shadow: none !important
    border-color: unset !important
    background-size: contain !important
  &__comment
    width: 50%
    margin: auto !important
    .text_area
      .v-label
        color: black
      fieldset
        border: 2px solid
        color: black !important
      &.error--text
        fieldset
          color: red !important
    .v-input
      color: black
  &__info_user
    margin-top: 130px
    color: black
    & > div
      display: flex
      justify-content: center
      align-items: center
      .avatar
        border: 5px solid black
      .name
        margin-left: 15px
        font-weight: bold
        font-size: 1.4rem
        line-height: 70px
        max-width: 250px
        white-space: nowrap
        overflow: hidden
        text-overflow: ellipsis
  &__content
    margin: auto
    width: 60%
    height: 120px
    max-height: 120px
    span
      color: black
      font-size: 2.0rem
      font-weight: 500
  &__action
    .btn_action
      background-color: transparent !important
      color: #848282
      border: 1px solid #d4d4d4
      border-radius: 20px
      padding: 0px 30px !important
      font-weight: bold
      font-size: 1rem
.other
  .happy_birthday
    &__content
      margin: auto
      width: 50%
      height: 50px
      line-height: 40px
      max-height: 60px
      span
        font-size: 2.0rem
    &__point
      margin: auto
      width: 50%
      color: black
      &__btn
        border-radius: 50%
        width: 35px !important
        height: 35px !important
        min-width: 35px !important
        padding: 0 !important
        background-color: #f8d253 !important
        font-weight: bold !important
        color: black
        font-size: 0.9rem
        position: relative
        &.active
          background-color: #f68f3c !important
          color: white !important
        &::after
          content: ''
          position: absolute
          left: -3px
          top: -3px
          width: 41px
          height: 41px
          border: 3px dashed #f68f3c
          border-radius: 50%
    &__info_user
      margin-top: 100px
      color: black
      .name
        font-size: 1.2rem
        max-width: 230px
        white-space: nowrap
        overflow: hidden
        text-overflow: ellipsis
    &__action
      &.send_point
        .send_point__btn
          background-color: #f68f3c !important
          border-radius: 25px
          height: 30px
          padding: 2px 20px !important
          position: relative
          font-weight: bold
          max-width: 160px
          width: 160px
          &::after
            content: ''
            position: absolute
            width: 170px
            left: -5px
            top: -5px
            border-radius: 25px
            border: 1px solid #f68f3c
            height: 41px
    &__comment
      width: 60%
</style>
